<!-- 用户心声 -->
<template>
    <div class="container">
        <header class="header">
            <p class="headerP1">筛选</p>
            <div style="height:0.34rem;border-right:1px solid #ED7046;width: 1px;margin-right: 0.24rem;"></div>
            <el-input v-model="init.q.userName" clearable placeholder="搜索用户名"
                      size="small"
                      style="width: 2rem;margin-right: 0.1rem;"></el-input>
            <el-select v-model="init.q.status" clearable placeholder="状态" size="small" style="margin-right: 0.1rem;">
                <el-option :value="1" label="正常"></el-option>
                <el-option :value="0" label="隐藏"></el-option>
            </el-select>
            <el-button icon="el-icon-search" size="small" type="primary" @click="init.page = 1, getData()">查询
            </el-button>
            <el-button icon="el-icon-refresh" size="small" @click="resetClick">重 置</el-button>
        </header>

        <!-- 评论列表 -->
        <div v-loading="loading" class="review-list">
            <div v-for="item in tableData" :key="item.id" class="review-item">
                <div class="review-header">
                    <el-avatar :size="48" :src="item.userImage" class="user-avatar">
                        <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"/>
                    </el-avatar>
                    <div class="user-info">
                        <p class="user-name">{{ item.userName }}</p>
                        <p class="create-time">{{ formatDate(item.createTime) }}</p>
                    </div>
                </div>
                <div class="review-content">{{ item.content }}</div>
                <div class="review-footer">
                    <span class="action-btn" @click="handleLike(item)">
                        <i :class="item.isLiked ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                        点赞 {{ item.likeCount || 0 }}
                    </span>
                    <span :class="{ active: currentReplyId === item.id }" class="reply-btn" @click="toggleReply(item)">
                        <i class="el-icon-chat-dot-square"></i>
                        回复 
                    </span>
                </div>

                <!-- 平台回复列表 -->
                <div v-if="item.commentList && item.commentList.length > 0" class="reply-list">
                    <div v-for="reply in item.commentList" :key="reply.id" class="reply-item">
                        <div class="reply-header">
                            <el-avatar :size="32" :src="reply.userImage || defaultPlatformAvatar"
                                       class="reply-avatar"></el-avatar>
                            <span class="reply-user-name">{{ reply.userName }}</span>
                            <span class="reply-time">{{ formatDate(reply.createTime) }}</span>
                        </div>
                        <div class="reply-content">{{ reply.content }}</div>
                    </div>
                </div>

                <!-- 回复输入框 -->
                <div v-if="currentReplyId === item.id" class="reply-input-wrap">
                    <el-input v-model="replyContent" :rows="2" maxlength="500" placeholder="请输入回复内容..."
                              show-word-limit type="textarea"></el-input>
                    <div class="reply-btn-group">
                        <el-button size="small" @click="cancelReply">取消</el-button>
                        <el-button :loading="replyLoading" size="small" type="primary" @click="submitReply(item)">回复
                        </el-button>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <el-empty v-if="!loading && tableData.length === 0" description="暂无评价数据"></el-empty>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrap">
            <Pagination :currentPage="init.page" :parentPageSize="init.size" :totalNumber="AllpagesNum"
                        @loadTable='loadTable'>
            </Pagination>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import Api from '@/components/Api/index'

export default {
    name: 'voiceOfTheCustomer',
    components: {Pagination},
    data() {
        return {
            loading: false,
            replyLoading: false,
            currentReplyId: null,
            replyContent: '',
            AllpagesNum: 0,
            tableData: [],
            defaultPlatformAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            init: {
                page: 1,
                q: {},
                size: 10
            },
        }
    },
    methods: {
        // 获取列表数据
        getData() {
            this.loading = true
            new Api().postList(this.init).then(res => {
                if (res.status === 200) {
                    this.tableData = res.data.records || []
                    this.AllpagesNum = res.data.total || 0
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 格式化时间戳
        formatDate(timestamp) {
            if (!timestamp) return ''
            const date = new Date(timestamp)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}`
        },
        // 点赞
        handleLike(item) {
            // TODO: 接口对接时替换为真实请求
            item.isLiked = !item.isLiked
            item.likeCount += item.isLiked ? 1 : -1
            this.$message({type: 'success', message: item.isLiked ? '点赞成功' : '已取消点赞'})
        },
        // 切换回复框显示
        toggleReply(item) {
            if (this.currentReplyId === item.id) {
                this.currentReplyId = null
                this.replyContent = ''
            } else {
                this.currentReplyId = item.id
                this.replyContent = ''
            }
        },
        // 取消回复
        cancelReply() {
            this.currentReplyId = null
            this.replyContent = ''
        },
        // 提交回复
        submitReply(item) {
            if (!this.replyContent.trim()) {
                this.$message({type: 'warning', message: '请输入回复内容'})
                return
            }
            this.replyLoading = true
            new Api().createPostComment({
                postId: item.id,
                content: this.replyContent
            }).then(res => {
                if (res.status === 200) {
                    const newReply = res.data || {
                        id: Date.now(),
                        postId: item.id,
                        createId: 0,
                        userName: '平台',
                        userImage: null,
                        parentId: null,
                        content: this.replyContent,
                        likeCount: null,
                        status: null,
                        createTime: Date.now()
                    }
                    if (!item.commentList) {
                        this.$set(item, 'commentList', [])
                    }
                    item.commentList.push(newReply)
                    item.commentCount = (item.commentCount || 0) + 1
                    this.$message({type: 'success', message: '回复成功'})
                    this.replyContent = ''
                    this.currentReplyId = null
                } else {
                    this.$message({type: 'error', message: res.statusText || '回复失败'})
                }
            }).catch(() => {
                this.$message({type: 'error', message: '回复失败'})
            }).finally(() => {
                this.replyLoading = false
            })
        },
        // 重置筛选
        resetClick() {
            this.init.q = {
                userName: '',
                status: ''
            }
            this.init.page = 1
            this.getData()
        },
        // 分页切换
        loadTable(page, size) {
            this.init.size = size
            this.init.page = page
            this.getData()
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: calc(100vh - 0.9rem);
    display: flex;
    flex-direction: column;

    .header {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        color: #ED7046;
        margin-bottom: 0.2rem;
        background-color: #fff;
        height: 0.6rem;
        border-radius: 0.1rem;
        padding: 0 0.3rem;

        .headerP1 {
            margin-right: 0.2rem;
        }
    }

    .review-list {
        flex: 1;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 0.1rem;
        padding: 0.2rem;
    }

    .pagination-wrap {
        flex-shrink: 0;
        padding: 0.16rem 0;
        background-color: #fff;
        border-radius: 0.1rem;
        margin-top: 0.12rem;
    }

    .review-item {
        padding: 0.24rem;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
            border-bottom: none;
        }

        .review-header {
            display: flex;
            align-items: center;
            margin-bottom: 0.16rem;

            .user-avatar {
                margin-right: 0.16rem;
                flex-shrink: 0;
            }

            .user-info {
                .user-name {
                    font-size: 0.16rem;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 0.04rem;
                }

                .create-time {
                    font-size: 0.12rem;
                    color: #999;
                }
            }
        }

        .review-content {
            font-size: 0.15rem;
            color: #555;
            line-height: 1.6;
            padding-left: 0.64rem;
            margin-bottom: 0.16rem;
            word-break: break-all;
        }

        .review-footer {
            padding-left: 0.64rem;
            display: flex;
            gap: 0.24rem;

            .action-btn {
                cursor: pointer;
                font-size: 0.14rem;
                color: #999;
                display: flex;
                align-items: center;
                gap: 0.04rem;
                transition: color 0.2s;

                &:hover {
                    color: #ED7046;
                }

                i {
                    font-size: 0.16rem;
                }

                .el-icon-star-on {
                    color: #ED7046;
                }
            }

            .reply-btn {
                cursor: pointer;
                font-size: 0.14rem;
                color: #fff;
                background-color: #ED7046;
                display: flex;
                align-items: center;
                gap: 0.04rem;
                padding: 0.06rem 0.16rem;
                border-radius: 0.04rem;
                transition: all 0.2s;

                &:hover,
                &.active {
                    background-color: #d65a30;
                }

                i {
                    font-size: 0.16rem;
                }
            }
        }

        .reply-list {
            margin-top: 0.16rem;
            margin-left: 0.64rem;
            background-color: #fafafa;
            border-radius: 0.08rem;
            padding: 0.16rem;

            .reply-item {
                padding: 0.12rem 0;

                &:not(:last-child) {
                    border-bottom: 1px dashed #e8e8e8;
                }

                .reply-header {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.08rem;

                    .reply-avatar {
                        margin-right: 0.08rem;
                        flex-shrink: 0;
                    }

                    .reply-user-name {
                        font-size: 0.14rem;
                        font-weight: 600;
                        color: #ED7046;
                        margin-right: 0.12rem;
                    }

                    .reply-time {
                        font-size: 0.12rem;
                        color: #999;
                    }
                }

                .reply-content {
                    font-size: 0.14rem;
                    color: #666;
                    line-height: 1.5;
                    padding-left: 0.4rem;
                }
            }
        }

        .reply-input-wrap {
            margin-top: 0.16rem;
            margin-left: 0.64rem;
            padding: 0.16rem;
            background-color: #fafafa;
            border-radius: 0.08rem;

            .reply-btn-group {
                margin-top: 0.12rem;
                display: flex;
                justify-content: flex-end;
                gap: 0.08rem;
            }
        }
    }
}
</style>
